/* eslint-disable radix, no-plusplus, @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import stringMask from 'string-mask';
import { CpfCnpjUtils } from './cpfCnpjUtils';

export const cpfMask = (value: string): string => {
  if (!value) return '';

  return `${value}`
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const cnpjMask = (value: string): string => {
  if (!value) return '';

  return `${value}`
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const genericMask = (value: string | number, mask: string) => {
  var i = value.length;
  var saida = mask.substring(0, 1);
  var texto = mask.substring(i);
  if (texto.substring(0, 1) !== saida) {
    value += texto.substring(0, 1);
  }
  return value;
};

export const boletoMask = (value: string): string => {
  if (!value) return '';

  var formatter = new stringMask('99999.99999 99999.999999 99999.999999 9 99999999999999');

  return formatter.apply(value);
};

export const dateMask = (value: string): string => {
  if (!value) return '';

  const sanitizedDate = `${value}`.replace(/\D/g, '');

  if (sanitizedDate.length === 2) {
    return `${sanitizedDate}/`;
  } else if (sanitizedDate.length === 4) {
    return `${sanitizedDate.replace(/(\d{2})(\d)/, '$1/$2').replace(/(\d{2})(\d)/, '$1/$2')}/`;
  }

  return sanitizedDate
    .replace(/(\d{2})(\d)/, '$1/$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(-\d{4})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export const phoneMask = (value: string): string => {
  if (!value) return '';

  const clearValue = `${value}`.replace(/\D/g, '');

  if (clearValue.length && clearValue.length <= 2) {
    return `(${clearValue}`;
  }

  if (clearValue.length <= 10) {
    return clearValue.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
  }

  return clearValue.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');

  // console.log('clearValue', );

  // const phone = `${value}`
  //   .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
  //   .replace(/(\d{2})(\d)/, '($1) $2');

  // if (`${value}`.replace(/\D/g, '').length <= 10) {
  //   return phone.replace(/(\d{4})(\d)/, '$1-$2');
  // }
  // return `${value}`.replace(/(\d{5})(\d)/, '$1-$2');
};

export const cellPhoneMask = (value: string): string => {
  if (!value) return '';

  const phone = `${value}`
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '($1) $2'); // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero

  if (`${value}`.replace(/\D/g, '').length <= 10) {
    return phone.replace(/(\d{4})(\d)/, '$1-$2');
  }

  return `${value}`.replace(/(\d{5})(\d)/, '$1-$2');
};

export const cepMask = (value: string): string => {
  return value
    ? `${value}`
        .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
        .replace(/(\d{5})(\d)/, '$1-$2')
    : ''; // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
};

export const testCpf = (receivedCpf: string): boolean => {
  try {
    const cpf = receivedCpf.replace(/[^\d]+/g, '');
    let numeros;
    let digitos;
    let soma;
    let i;
    let resultado;
    let digitos_iguais;
    digitos_iguais = 1;
    if (cpf.length !== 11) return false;
    for (i = 0; i < cpf.length - 1; i++) {
      if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
        digitos_iguais = 0;
        break;
      }
    }
    if (!digitos_iguais) {
      numeros = cpf.substring(0, 9);
      digitos = cpf.substring(9);
      soma = 0;
      for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado !== parseInt(digitos.charAt(0))) return false;
      numeros = cpf.substring(0, 10);
      soma = 0;
      for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      return resultado === parseInt(digitos.charAt(1));
    }
    return false;
  } catch (e) {
    return false;
  }
};

export const testCNPJ = (receivedCnpj: string): boolean => {
  const cnpj = receivedCnpj.replace(/[^\d]+/g, '');

  if (!cnpj) return false;

  if (cnpj.length !== 14) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999'
  )
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== digitos.charAt(0)) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== digitos.charAt(1)) return false;

  return true;
};

export const splitName = (fullname: string): { lastName: string; middleName: string; firstName: string } => {
  const parts = fullname.split(' ');
  const firstName = `${parts.shift()}`;
  const lastName = `${parts.pop()}`;
  const middleName = `${parts.join(' ')}`;

  return {
    firstName,
    lastName,
    middleName,
  };
};

export const cpfCnpjMask = (receivedTaxId: string) => {
  if (!receivedTaxId) return false;

  const taxId = receivedTaxId.replace(/\D/g, '');

  if (taxId.length > 11) {
    return CpfCnpjUtils.formatCnpj(taxId);
  } else if (taxId.length <= 11) {
    return CpfCnpjUtils.formatCpf(taxId);
  }
};

export const dateMask2 = (date: string) => {
  if (!date) return '';

  let v = date.replace(/\D/g, '').slice(0, 10);

  if (v.length >= 5) {
    return `${v.slice(0, 2)}/${v.slice(2, 4)}/${v.slice(4)}`;
  } else if (v.length >= 3) {
    return `${v.slice(0, 2)}/${v.slice(2)}`;
  }
  return v;
};

export const moneyMask = (value: string | number, isOnlyNumeric: boolean = false) => {
  value = String(value).replaceAll('.', '').replaceAll(',', '').replaceAll(/\D/g, '');

  if (`${value}`.length === 0) return '';

  const options = { minimumFractionDigits: 2 };
  const result = new Intl.NumberFormat('pt-BR', options).format(parseFloat(value) / 100);

  if (isOnlyNumeric) {
    return result.replaceAll('.', '').replace(',', '.');
  }

  return result;
};
